import { Injectable } from '@angular/core';
import {ApiConfigService} from "../../../shared-services/api-config.service";

@Injectable({
  providedIn: 'root'
})
export class SiteEntityService {

  constructor(private apiConfigService: ApiConfigService) { }

  saveToBackend(siteDto){
    return this.apiConfigService.post('api/site/create',siteDto);
  }

  deleteFromBackend(siteId){
      return this.apiConfigService.get('api/site/delete/'+siteId);
  }
}
